<template>
	<div>
		<el-form ref="zSearch"
			:model="searchData"
			:label-position="searchObj.labelPosition"
			:label-width="`${searchObj.labelWidth}px`"
			:label-suffix="searchObj.labelSuffix"
			:hide-required-asterisk="searchObj.hideRequiredAsterisk"
			:show-message="searchObj.showMessage"
			:inline-message="searchObj.inlineMessage"
			:status-icon="searchObj.statusIcon"
			:validate-on-rule-change="searchObj.validateOnRuleChange"
			:size="searchObj.size || 'medium'"
			:disabled="searchObj.disabled">
			<el-form-item v-for="(searchItem,$index) in searchObj.searchArr"
				:key="$index"
				:label="searchItem.label"
				:prop="searchItem.prop">
				<!-- 输入框 -->
				<el-input v-if="searchItem.type=='input'"
					:placeholder="searchItem.placeholder || '请填写内容'"
					v-model="searchData[searchItem.prop]"></el-input>
				<!-- 年月日选择器 -->
				<el-date-picker v-if="searchItem.type=='date'"
					v-model="searchData[searchItem.prop]"
					value-format="yyyy-MM-dd"
					type="date"
					:placeholder="searchItem.placeholder || '请选择日期'">
				</el-date-picker>
				<!--年月日范围选择器-->
				<el-date-picker v-if="searchItem.type=='dateRange'"
					type="daterange"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					v-model="searchData[searchItem.prop]"
					value-format="yyyy-MM-dd">
				</el-date-picker>
				<!--年月日时分秒选择器-->
				<el-date-picker v-if="searchItem.type=='datetime'"
					type="datetime"
					:placeholder="searchItem.placeholder || '请选择时间'"
					v-model="searchData[searchItem.prop]"
					value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
				<!--年月日时分秒范围选择器-->
				<el-date-picker v-if="searchItem.type=='datetimerange'"
					type="datetimerange"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					v-model="searchData[searchItem.prop]"
					value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
				<!-- select选择器 -->
				<el-select v-if="searchItem.type=='select'"
					v-model="searchData[searchItem.prop]"
					:placeholder="searchItem.placeholder">
					<el-option :label="searchItem.props ? options[searchItem.props.label] : options.label"
						:value="searchItem.props ? options[searchItem.props.value] : options.value"
						v-for="(options, index) in searchItem.options"
						:key="index">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item>
				<el-button type="primary"
					@click="searchOk"
					:loading="searchObj.searchLoading">查询
				</el-button>
				<el-button plain
					@click="searchReset">重置</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
	export default {
		name: 'z-search',
		props: {
			searchObj: {
				type: Object,
				required: true
			},
			searchData: {
				type: Object,
				required: true
			},
		},
		methods: {
			// 搜索确认
			searchOk() {
				this.$emit('searchOperation', true);
			},
			// 重置
			searchReset() {
				this.$emit('searchOperation', false);
			},

		},
	}
</script>

<style lang="scss"
	scoped>
	$width: 200px;

	form {
		display: flex;
	}

	.el-form-item {
		display: flex;
		align-items: center;
		margin-right: 10px;
	}

	::v-deep .el-form-item__label {
		display: flex;
		background-color: #f5f7fa;
		align-items: center;
		height: 36px;
		padding: 0 12px;
		border: 1px solid #DCDFE6;
	}

	::v-deep .el-input__inner {
		border-radius: unset;
	}

	.el-date-editor.el-input {
		width: $width;
	}

	.el-select {
		width: $width;
	}
</style>
